<template>
  <div :class="[{ 'nav-open': $sidebar.showSidebar }]" class="wrapper">
    <notifications />

    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <!-- <user-menu /> -->
      <!-- <mobile-menu /> -->

      <template slot="links">
        <sidebar-item class="user-profile-item" style="padding-bottom: 1rem;" :link="{ name: title, icon: 'person_outline', path: '/portal/member' }">
          <sidebar-item :link="{ name: 'My Settings', icon: 'settings', path: '/portal/member/my-settings' }" />
        </sidebar-item>
        <span class="user-role">{{ role || 'Member' }}</span>
        <div style="border-bottom: solid 1px rgba(180, 180, 180, .3);margin-left: 1rem;margin-right: 1rem;"></div>

        <sidebar-item :link="{ name: 'Dashboard', icon: 'home', path: '/portal/member/dashboard' }" />

        <sidebar-item :link="{ name: 'Messages', icon: 'mail_outline', path: '/portal/member/messages' }" />

        <sidebar-item :link="{ name: 'Reports', icon: 'remove_red_eye', path: '/portal/member/reports' }" />

        <!-- <sidebar-item :link="{ name: 'Referrals', icon: 'add_to_queue', path: '/portal/member/referrals' }" /> -->

        <!-- <sidebar-item :link="{ name: 'History', icon: 'history', path: '/portal/member/history' }" /> -->
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar class="top-navbar" />

      <!--
      <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>
      -->

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view style="margin-top: 40px;" />
        </zoom-center-transition>
      </div>

      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar"
import "perfect-scrollbar/css/perfect-scrollbar.css"

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

import TopNavbar from "./TopNavbar.vue"
import ContentFooter from "./ContentFooter.vue"
import MobileMenu from "./Extra/MobileMenu.vue"
//import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue"
import { ZoomCenterTransition } from "vue2-transitions"

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    //FixedPlugin,
    UserMenu,
    ZoomCenterTransition
  },
  props: {
    title: {
      type: String,
      default: sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    },
    role: {
      type: String,
      default: sessionStorage.getItem("usertype")
    }
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "", //"./img/sidebar-0.jpg"
      sidebarMini: false,
      sidebarImg: true
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    }
  },
  mounted() {
    let docClasses = document.body.classList
    let isWindows = navigator.platform.startsWith("Win")
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar")
      initScrollbar("sidebar-wrapper")
      initScrollbar("main-panel")

      docClasses.add("perfect-scrollbar-on")
    } else {
      docClasses.add("perfect-scrollbar-off")
    }
    this.maximixeSidebar()
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    maximixeSidebar() {
      this.$sidebar.toggleMinimize()
    }
  }
}
</script>

<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
